/**
 * Returns a new array with values from index to numberToRemove removed and newValues inserted.
 */
export function splice<T>(arr: readonly T[], index: int, numberToRemove: int = 0, ...newValues: T[]): T[] {
  const newArr = [...arr];
  newArr.splice(index, numberToRemove, ...newValues);

  return newArr;
}